import { TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';
import React from 'react';

export default function UnderlineTextInput({ ...props }: TextFieldProps) {
    return <TextField {...props} variant="standard" />;
}
